import usePostData from '../../../../../hooks/postHook';

export const useAddService = ({ id }) => {
  const [{ data, body, isLoading, isError, error }, doAddService] = usePostData(
    `admin_brand/${id}/services`
  );

  return { data, body, isLoading, isError, error, doAddService };
};
